import { combineReducers } from 'redux';
import workflow from './workflow';
import bankStatements from './bankStatements';

const createRootReducer = () => combineReducers({
  workflow,
  bankStatements,
});

export default createRootReducer;
